/**
 * What a tap on the phone's Create / Take dock does (Blockari's QuickNav).
 *
 * The lit button is the screen you are on. Tapping it again is not a navigation: re-opening the screen would
 * refetch it and throw away what the player has typed or picked (a wager, a code in its slots), so it only takes
 * them back to the top of it, as an active tab does. Any other tap goes to its screen.
 */
export type DockTarget = 'create' | 'take';

export function dockTapAction(current: DockTarget | null, tapped: DockTarget): 'go' | 'top' {
  return current === tapped ? 'top' : 'go';
}
